<template>
  <div class="page">
    <div class="header-section">
      <div class="head-context">
        <div>
          <p class="weight">Mengyuan Ren, Doctor</p>
          <p>
            <span class="weight">Titile/Position:</span> Ph.D
          </p>
        </div>
        <div>
          <div class="weight">Affiliation:</div>
          <div>
            Institute of Reproductive and Child Health, School of Public
            Health,<br />
            Peking University, Beijing 100191, P.R. China
          </div>
        </div>
        <div>
          <span class="weight">Websiute: </span>
          <a href="https://www.researchgate.net/profile/Mengyuan-Ren " target="_blank" class="blue">https://www.researchgate.net/profile/Mengyuan-Ren</a>
        </div>
        <div>
          <span class="weight">Email: </span>
          <span class="blue">myren@bjmu.edu.cn</span>
        </div>
      </div>
      <div class="img">
        <img class="head" :src="img" alt="" />
      </div>
    </div>
    <div class="section">
      <div class="weight">Brief introduction:</div>
      <div class="content">
        My main interest is to explore the relationships and reveal the mechanisms between exposome and human health. Recently, I focus on establishing integrated analytical framework in identifying disease-specific sensitive biomarkers among environmental exposures in mixture, and building interpretable prediction models using advanced machine learning algorithms. I have published a total of 6 peer-reviewed publications as the first or corresponding author. The publication journals mainly include the areas of environmental science and reproductive health, e.g., Environ Int, The Innovation, Environ Pollu, and Sci Total Environ.
      </div>
    </div>
    <div class="section">
      <div class="weight">Representative papers:</div>
      <p>
        1. <span class="weight">Ren M</span>, Wu T, Yang S, Gao N, Lan C, Zhang H, Lin W, Su S, Yan L, Zhuang L, Lu Q, Xu J, Han B, Bai Z, Meng F, Chen Y, Pan B, Wang B *, Lu X, Fang M. Ascertaining Sensitive Exposure Biomarkers of Various Metal(loid)s to Embryo Implantation. Environ Pollu. 2024, 347: 123679.
      </p>
      <p>
        2. <span class="weight">Ren M</span>, Fang M, Liu J, Lu Q, Bao H, Zhuang L, Meng F, Pan B, Yan L, Li Z, Xu J, Han B, Bai Z, Tian C, Wang Y, Wang B*. Applying hair exposome for linking environmental exposure to reproductive health: a comprehensive review and research perspective. Hygiene and Environmental Health Advances. 2024, 9: 100086.
      </p>
      <p>
        3. <span class="weight">Ren M</span>#, Zhao J#, Wang B*, An H, Li Y, Jia X, Wang J, Wang S, Yan L, Liu X, Pan B, Li Z, Ye R. Associations between hair levels of trace elements and the risk of preterm birth among pregnant women: A prospective nested case-control study in Beijing Birth Cohort (BBC), China. Environ Int. 2022, 158: 106965.
      </p>
      <p>
        4. <span class="weight">Ren M</span>#, Pei R#, Jiangtulu B#, Chen J#, Xue T, Shen S, Yuan X, Li K, Lan C, Chen Z, Chen X, Wang Y, Jia X, Li Z, Rashid A, Prapamontol T, Zhao X, Dong Z, Zhang Y, Zhang L, Ye R, Li Z, Guan W*, Wang B*. Contribution of temperature increase to restrain the transmission of COVID-19 in China. The Innovation, 2020, 2: 100071.
      </p>
      <p>
        5. <span class="weight">Ren M</span>#, Yan L#, Pang Y, Jia X, Huang J, Shen G, Cheng H, Wang X, Pan B, Li Z, Wang B*. External interference from ambient air pollution on using hair metal(loid)s for biomarker-based exposure assessment. Environ Int. 2020, 137: 105584.
      </p>
      <p>
        6. <span class="weight">Ren M</span>, Jia X, Shi J, Yan L, Li Z, Lan C, Chen J, Li N, Li K, Huang J, Wu S, Lu Q, Li Z*, Wang B*, Liu J. Simultaneous analysis of typical halogenated endocrine disrupting chemicals and metal(loid)s in human hair. Sci Total Environ. 2020, 718: 137300.
      </p>
      <p>
        7. Jia X#, Zhang L#, Zhao J, <span class="weight">Ren M</span>, Li Z, Wang J, Wang S, Liu Y, An H, Li Y, Yan L, Li Z*, Liu X*, Pan B*, Ye R. Associations between endocrine-disrupting heavy metals in maternal hair and gestational diabetes mellitus: A nested case-control study in China. Environ Int. 2021, 157: 106770.
      </p>
      <p>
        8. Pang Y#, Yan L#, <span class="weight">Ren M</span>, Jia X, Liu T, Du W, Wang B, Li Z*, Lu Q*. Environmental complex exposure and the risk of influenza-like illness among housewives: A case study in Shanxi Province, China. Ecotox Environ Safe. 2020, 194: 110405.
      </p>
      <p>
        9. Jia, X, <b>Ren, M</b>, Zhang, Y, Ye, R, Zhang, L, Li, Z. Association between tea drinking and plasma folate concentration among women aged 18–30 years in China. Public Health Nutr. 2020, 24(15), 4929-4936.
      </p>
      <p>
        10.Wang T, <b>Ren M</b>, Shen Y, Zhu X, Zhang X, Gao M, Chen X, Zhao A, Shi Y, Chai W, Liu X, Sun X*. The Association Among Social Support, Self-Efficacy, Use of Mobile Apps, and Physical Activity: Structural Equation Models With Mediating Effects. JMIR mHealth uHealth. 2019, 7(9): e12606.
      </p>
      <div>Note：* Corresponding author, # Co-first author</div>
    </div>
  </div>
</template>
<script>
import img from '@/assets/people/rmy.jpg';
export default {
  data() {
    return {img};
  },
  methods: {},
};
</script>
<style scoped lang="scss">
.page {
  overflow: auto;
  padding: 20px 30px;
  text-align: left;
  font-size: $webpage-base-font-size;
}
.header-section {
  display: flex;
}
.head-context {
  display: flex;
  flex-direction: column;
  gap: 18px
}
.head {
  height: 200px;
  margin-left: 160px;
}
p {
  word-break: break-word;
  overflow: hidden;
  text-align: left;
  line-height: $line-height-x-large;
  margin-bottom: 0;
}
.content {
  word-break: break-word;
  overflow: hidden;
  text-align: left;
  line-height: $line-height-x-large;
}
.weight {
  font-weight: 600
}
.section {
  margin-top: 20px;
  padding-right: 25px;
}
.blue {
  color: $blue-light-1
}
.img {
  display: flex;
  align-items: center;
}
@media screen and (max-width: 600px) {
  .header-section {
    display: flex;
    flex-direction: column;
  }
  .head {
    margin-left: 0;
    margin-top: 18px
  }
}
</style>

